import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetAllResponse } from '../model/restful-api.model';
import { environment } from 'src/environments/environment';
import { API_URL } from '../enums/api-enums';
import { TicketRequest } from '../model/ticket-access-request.model';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { Observable } from 'rxjs';
import { RenTT } from '../model/renTT.model';

@Injectable({
  providedIn: 'root'
})

export class RenTTService {

  constructor(private utilities: UtilitiesService, private http: HttpClient) { }

  requestRenTTAccess(body): Observable<GetAllResponse<RenTT>> {
    const url = environment.portalURL + API_URL.RENTT_REQUEST_URL;
    return this.utilities.req.httpPost<GetAllResponse<RenTT>>(url, body);
  }

  getRequestRenTTAccess(id): Observable<GetAllResponse<RenTT>> {
    const url = environment.portalURL + API_URL.RENTT_REQUEST_URL + `${id}`;
    return this.utilities.req.httpGet<GetAllResponse<RenTT>>(url);
  }

  getRequestRenTTAccessList(): Observable<GetAllResponse<TicketRequest>> {
    const url = environment.portalURL + API_URL.RENTT_REQUEST_URL;
    return this.utilities.req.httpGet<GetAllResponse<TicketRequest>>(url);
  }

}
